module.exports = __webpack_public_path__ + "assets/285d046a1a6cb3f91b7a267ba3cd211d.png";